// A technology's class by its name (see Constants/Technologies), or null. Every class in the technologies module is
// found by the name it gives (GetName), so a new technology only has to be added there.
const Technologies = require('../Constants/Technologies/Technologies');

let byName = null;

const TechnologyLookup = (techType) =>
{
    byName ??= new Map(Object.values(Technologies).map(Technology => [Technology.GetName(), Technology]));
    return byName.get(techType) ?? null;
}

module.exports = TechnologyLookup;
